import { SYSTEM_LOINC } from '@ctw/shared/api/fhir/system-urls';
import type {
  FilterChangeEvent,
  FilterItem,
} from '@ctw/shared/components/filter-bar/filter-bar-types';
import { ValueSets } from '@ctw/shared/utils/value-sets';

interface LoincValueSet {
  key: string;
  display: string;
  loincCodes: Array<string>;
}

const loincValueSets: Array<LoincValueSet> = Object.entries(ValueSets).map(([key, vs]) => ({
  key,
  display: vs.display,
  loincCodes: vs.content.filter((x) => x.system === SYSTEM_LOINC).map((c) => c.code),
}));

export const filters: Array<FilterItem> = [
  {
    key: 'loincCode',
    display: 'Observations',
    type: 'checkbox',
    values: loincValueSets.map((vs) => ({
      key: vs.key,
      name: vs.display,
    })),
  },
];

export const defaultFilters: FilterChangeEvent = {
  loincCode: {
    key: 'loincCode',
    type: 'checkbox',
    selected: [loincValueSets[0]?.key],
  },
};
